import {Box, Button, Divider, Stack} from '@mui/material';
import React, {Fragment} from 'react';

import {AppointmentBookingEnum, WellBornTaggingEnum} from 'main/analytics/gaTagsEnum';
import {AlertInfo, EmptySearchState} from 'presentation/components';
import {PhonesDrawer} from 'presentation/components/PhonesDrawer';
import {PhonesMenu} from 'presentation/components/PhonesMenu';
import {CopySectionMaskEnum} from 'presentation/constants';
import {translations} from 'presentation/translations-new';
import {useSpecialtyNotAvailableBeBornCard} from './hooks/useSpecialtyNotAvailableBeBornCard';
import {SpecialtyNotAvailableBeBornCardProps} from './types';
import {Loading} from 'presentation/components/Loading/Loading';

const {specialtyNotFound, unitsFlow} = translations['pt-br'].privateFlow.bookingFlow;
const {choosePhoneNumber} = translations['pt-br'].privateFlow.bookingFlow.unitsFlow.unitDetails;
const {call} = translations['pt-br'].commons;
const {bookingGynecology} = translations['pt-br'].privateFlow.bookingFlow.unitsFlow.notFoundModal;
const {beBornWellInfos} = translations['pt-br'].privateFlow.bookingFlow.beBornWellFlow;

export const SpecialtyNotAvailableBeBornCard = ({
	handleSelectCard,
	handleCheckDuplicity,
}: SpecialtyNotAvailableBeBornCardProps) => {
	const {
		handleCallChatRoom,
		openPhoneDrawerState,
		handleTogglePhoneDrawer,
		isPhoneNumberMenuOpen,
		anchorEl,
		handleOpenPhoneMenu,
		handleClosePhoneMenu,
		handleGynecologyClick,
		isMobile,
		callChatRoomIsLoading,
	} = useSpecialtyNotAvailableBeBornCard({
		handleSelectCard,
		handleCheckDuplicity,
	});

	return (
		<Fragment>
			<EmptySearchState
				dataTagId={WellBornTaggingEnum.VISUALIZOU_CARD_DE_RECUSA}
				title={unitsFlow.notFoundModal.specialtyNotAvailableOnlineTitle}
				description={unitsFlow.notFoundModal.gynecologyNotAvailableOnlineDescription}
				imageV2>
				<Stack gap={2}>
					<Button
						onClick={handleCallChatRoom}
						variant="contained"
						size="large"
						disabled={callChatRoomIsLoading}
						endIcon={
							callChatRoomIsLoading ? <Loading size={16} color="inherit" /> : null
						}>
						{specialtyNotFound.secondaryButton}
					</Button>
					<Button
						variant={'outlined'}
						size="large"
						data-tag-id={AppointmentBookingEnum.CLICK_LIGAR_AGENDAMENTO}
						onClick={handleOpenPhoneMenu}>
						{call}
					</Button>
					<Divider />
					<Button
						data-tag-id={WellBornTaggingEnum.CLICK_AGENDAR_GINECOLOGIA_CLINICA}
						variant="outlined"
						size="large"
						onClick={handleGynecologyClick}>
						{bookingGynecology}
					</Button>
				</Stack>
			</EmptySearchState>

			{isMobile ? (
				<PhonesDrawer.Root
					open={openPhoneDrawerState}
					toggleDrawer={handleTogglePhoneDrawer}
					title={choosePhoneNumber}>
					<AlertInfo.Root>{[beBornWellInfos.alert]}</AlertInfo.Root>

					<PhonesDrawer.Simple
						mask={CopySectionMaskEnum.PHONE_WITHOUT_DDD}
						phoneNumbers={[beBornWellInfos.telephoneNumber]}
					/>
				</PhonesDrawer.Root>
			) : (
				<PhonesMenu.Root
					open={isPhoneNumberMenuOpen}
					onClose={handleClosePhoneMenu}
					anchorEl={anchorEl}>
					<Box pb={2}>
						<AlertInfo.Root>{[beBornWellInfos.alert]}</AlertInfo.Root>
					</Box>

					<PhonesDrawer.Simple
						mask={CopySectionMaskEnum.PHONE_WITHOUT_DDD}
						phoneNumbers={[beBornWellInfos.telephoneNumber]}
					/>
				</PhonesMenu.Root>
			)}
		</Fragment>
	);
};
